export default function(node){return node.ownerDocument&&node.ownerDocument.defaultView||node.document&&node||node.defaultView}